import React from "react";
import { useLocation } from "react-router-dom";

const EXACT_PATHS = ["/"];

const PATH_PREFIXES = [
    "/educativo",
    "/cursos",
    "/diplomaturas",
    "/posgrados",
    "/servicios",
    "/fundacion",
    "/la-fundacion",
    "/fisp-uba",
];

const WHATSAPP_HREF = "https://wa.me/5491123879118";

function WhatsAppIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                fill="currentColor"
                d="M12.02 2.25c-5.38 0-9.74 4.24-9.74 9.47 0 1.67.45 3.3 1.31 4.73L2.25 21.75l5.52-1.3a9.9 9.9 0 0 0 4.25.95c5.38 0 9.74-4.24 9.74-9.48 0-5.22-4.36-9.47-9.74-9.47Zm0 17.54a8.3 8.3 0 0 1-4-.98l-.29-.17-3.28.77.8-3.18-.19-.31a8.04 8.04 0 0 1-1.21-4.2c0-4.34 3.65-7.87 8.17-7.87s8.17 3.53 8.17 7.87c0 4.35-3.65 7.88-8.17 7.88Zm4.48-5.96c-.25-.12-1.49-.72-1.73-.8-.23-.08-.4-.12-.56.12-.17.24-.65.8-.8.96-.15.16-.3.18-.56.06a6.69 6.69 0 0 1-1.97-1.2 7.44 7.44 0 0 1-1.37-1.67c-.14-.24-.02-.36.1-.48.11-.11.25-.28.37-.42.12-.14.16-.24.25-.4.08-.16.04-.3-.02-.42-.06-.12-.56-1.34-.77-1.83-.2-.48-.4-.41-.56-.42h-.48c-.17 0-.44.06-.67.3-.23.24-.88.85-.88 2.07s.9 2.4 1.03 2.57c.12.16 1.76 2.74 4.27 3.84.6.25 1.07.4 1.44.52.6.19 1.14.16 1.57.1.48-.07 1.49-.6 1.7-1.18.21-.58.21-1.08.15-1.18-.06-.1-.22-.16-.46-.28Z"
            />
        </svg>
    );
}

export default function EducativoWhatsAppFloat() {
    const location = useLocation();
    const shouldShow =
        EXACT_PATHS.includes(location.pathname) ||
        PATH_PREFIXES.some((prefix) => location.pathname.startsWith(prefix));

    if (!shouldShow) {
        return null;
    }

    return (
        <a
            className="educativo-whatsapp-float"
            href={WHATSAPP_HREF}
            target="_blank"
            rel="noreferrer"
            aria-label="Abrir WhatsApp de FISP"
            title="WhatsApp"
        >
            <WhatsAppIcon />
        </a>
    );
}
